import { CircularProgress } from "@mui/material";
import { useLoading } from "contexts/loading.context";

export default function LoadingScreenBlocker() {
  const { loading } = useLoading();

  return (
    <div
      style={
        loading
          ? {
              width: "100vw",
              height: "100vh",
              position: "fixed",
              top: 0,
              right: 0,
              backgroundColor: "rgba(255, 255, 255, 0.6)",
              zIndex: 2000,
              display: "grid",
              placeItems: "center",
              transition: "0.1s all ease",
              pointerEvents: "all",
            }
          : {
              width: "100vw",
              height: "100vh",
              position: "fixed",
              top: 0,
              right: 0,
              backgroundColor: "rgba(255, 255, 255, 0.0)",
              transition: "0.1s all ease",
              pointerEvents: "none",
            }
      }
    >
      {loading && <CircularProgress />}
    </div>
  );
}
